import * as React from 'react';

import styles from './formatted-summary-reponse-text.module.css';

type Props = {
    summaryText: string | null | undefined;
};

export function FormattedSummaryResponseText(props: Props) {
    const {summaryText} = props;

    return summaryText ? (
        <div>
            {summaryText.split('\n').map((summaryLine, index) => {
                return (
                    <div
                        key={`summary-line-${index}`}
                        className={summaryLine.length ? styles.line : styles['line--empty']}
                    >
                        {summaryLine}
                    </div>
                );
            })}
        </div>
    ) : null;
}
